import dynamic from 'next/dynamic';
export default dynamic(() => import(/* webpackChunkName:"FooterLite" */ './FooterLite').then((mod) => mod.default));
